import { render, staticRenderFns } from "./FMessageHistory.vue?vue&type=template&id=62ca0280&"
import script from "./FMessageHistory.vue?vue&type=script&lang=js&"
export * from "./FMessageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports